module.exports = __webpack_public_path__ + "img/making-1.6f05ba09.png";